import { createColDef } from '@fortem-monorepo/react-ag'

import { StrategyIdCellEditor } from '@/ag-grid/columns/strategy-id/cell-editor'
import { StrategyIdCellRenderer } from '@/ag-grid/columns/strategy-id/renderer'

export const strategy_id = createColDef({
  field: 'strategy_id',
  headerName: 'Strategy',
  cellRenderer: StrategyIdCellRenderer,
  cellEditor: StrategyIdCellEditor,
})
